module.exports = __webpack_public_path__ + "img/ubuntu-v14-latin-500.35201f6.svg";